import { SettingItem } from './index.d';

export enum Action {
  switch = 0, 
  jump = 1,
  frequentedPlace = 2,
}

export const settingList: SettingItem[]= [
  {
    action: Action.switch,
    value: false,
    title: '定位服务',
    desc: '开启后，将收集学生的定位信息。'
  },
  {
    action: Action.frequentedPlace,
    value: false,
    title: '常去地点',
    desc: '设置常去地点，优化定位不准问题。'
  },
  {
    action: Action.jump,
    value: false,
    title: '定位方式说明',
    desc: '了解定位的方式与内容。'
  }
]
